<template>
    <Sheet class="container">
        <span class="opps hidden-sm-and-down">OPPS!</span>
        <span class="opps sm hidden-md-and-up">OPPS!</span>
        <h1>404</h1>
        <h3>找不到此頁面!!</h3>
        <div>
            請按此
            <el-button
                    type="success"
                    style="margin: 0 2px;"
                    @click="onReturn"
            >
                回首頁
            </el-button>
            返回首頁
        </div>
    </Sheet>
</template>

<script>
    import ExceptionMixin from './ExceptionMixin';

    export default {
        name: 'NotFound',
        mixins:[ExceptionMixin]
    }
</script>

<style scoped>
    .container{
        text-align: center;
    }
    .container .opps{
        font-size: 4rem;
        font-weight: bolder;
    }
    .container .opps.sm{
        font-size: 2rem;
    }

</style>
